import { propertyService } from "@/api/property.service";

const cachedProperties = () => localStorage.getItem("properties");
const properties = cachedProperties();
export const state = {
  properties: properties ? JSON.parse(properties) : [],
  selectedPropertyId: null
}

export const actions = {
  getProperties({ commit, dispatch }, { resetCache, callback }){
    const cached = cachedProperties();
    if (!resetCache && cached && cached.length > 0) {
      commit("setProperties", cached);
      if (callback) callback();
    } else {
      propertyService.getProperties()
        .then(response => {
          commit("setProperties", response);
          if (callback) callback();
          dispatch("cacheProperties");
        });
    }
  },
  switchProperty({ commit, state }, { id, callback }){
    const property = state.properties.find(s => s.id == id);
    commit("setSelectedProperty", property);
    commit(
      'navigation/breadcrumbAdded',
      {
        text: property.name,
        level: 1,
        propertyId: id,
        to: `/properties/${id}`,
        active: true
      },
      { root: true }
    );
    if (callback) callback();
  },
  uploadPhoto({ commit, dispatch, state }, { file, callback }){
    const propertyId = state.selectedPropertyId;
    propertyService.uploadFile(propertyId, 'photos', file)
      .then(response => {
        commit("setPhotos", { propertyId: response.id, photos: response.photos });
        if (callback) callback();
        dispatch("cacheProperties")
      });
  },
  deletePhoto({ commit, dispatch, state }, { id, callback }){
    const propertyId = state.selectedPropertyId;
    propertyService.deleteFile(propertyId, 'photos', id)
      .then(response => {
        commit("setPhotos", { propertyId: response.id, photos: response.photos });
        if (callback) callback();
        dispatch("cacheProperties")
      });
  },
  uploadDocument({ commit, dispatch, state }, { file, callback }){
    const propertyId = state.selectedPropertyId;
    propertyService.uploadFile(propertyId, 'documents', file)
      .then(response => {
        commit("setDocuments", { propertyId: response.id, documents: response.documents });
        if (callback) callback();
        dispatch("cacheProperties")
      });
  },
  deleteDocument({ commit, dispatch, state }, { id, callback }){
    const propertyId = state.selectedPropertyId;
    propertyService.deleteFile(propertyId, 'documents', id)
      .then(response => {
        commit("setDocuments", { propertyId: response.id, documents: response.documents });
        if (callback) callback();
        dispatch("cacheProperties");
      });
  },
  cacheProperties({ state }) {
    localStorage.setItem("properties", JSON.stringify(state.properties));
  },
  clearProperties({ commit }) {
    commit("setProperties", null);
    commit("setSelectedProperty", { id: null });
    localStorage.removeItem("properties");
  },
  updateProperty({ commit, dispatch }, payload) {
    const propertyId = state.selectedPropertyId;
    propertyService.updateProperty(propertyId, payload)
      .then(data => {
        commit("setProperty", { propertyId, data });
        commit("menu/updateMenuItemLabel", { label: data.name, propertyId }, { root: true })
        commit("navigation/updateBreadcrumbLabel", { label: data.name, propertyId }, { root: true });
        dispatch('notification/success', 'Property updated.', { root: true });
        dispatch("cacheProperties");
      });
  }
};

export const mutations = {
  setProperties(state, properties) {
    state.properties = properties;
  },
  setSelectedProperty(state, property) {
    state.selectedPropertyId = property.id;
  },
  setPhotos(state, { propertyId, photos }){
    let property = state.properties.find(p => p.id == propertyId);
    property.photos = photos;
  },
  setAreaPhotos(state, { propertyId, areaId, photos}){
    let prop = state.properties.find(p => p.id == propertyId);
    let area = prop.areas.find(a => a.id == areaId);
    area.photos = photos;
  },
  setItemPhotos(state, { propertyId, areaId, itemId, photos }){
    let prop = state.properties.find(p => p.id == propertyId);
    let area = prop.areas.find(a => a.id == areaId);
    let item = area.items.find(i => i.id == itemId);
    item.photos = photos;
  },
  setDocuments(state, { propertyId, documents }){
    let prop = state.properties.find(p => p.id == propertyId);
    prop.documents = documents;
  },
  setAreaDocuments(state, { propertyId, areaId, documents}){
    let prop = state.properties.find(p => p.id == propertyId);
    let area = prop.areas.find(a => a.id == areaId);
    area.documents = documents;
  },
  setItemDocuments(state, { propertyId, areaId, itemId, documents }){
    let prop = state.properties.find(p => p.id == propertyId);
    let area = prop.areas.find(a => a.id == areaId);
    let item = area.items.find(i => i.id == itemId);
    item.documents = documents;
  },
  setProperty(state, { propertyId, data: { name, category } }){
    let prop = state.properties.find(p => p.id == propertyId);

    prop.name = name;
    prop.category = category;
  },
  setArea(state, { propertyId, areaId, data }){
    const prop = state.properties.find(p => p.id == propertyId);

    if (areaId) {
      const area = prop.areas.find(i => i.id == areaId);
      const { name, category, nickname, ceiling_height, floor_material_type, counter_top_material, counter_top_measurement, wall_material, additional_information } = data;

      area.name = name;
      area.category = category;
      area.nickname = nickname;
      area.ceiling_height = ceiling_height;
      area.floor_material_type = floor_material_type;
      area.counter_top_material = counter_top_material;
      area.counter_top_measurement = counter_top_measurement;
      area.wall_material = wall_material;
      area.additional_information = additional_information;
    } else prop.areas.push(data);
  },
  setItem(state, { propertyId, areaId, itemId, data }) {
    const prop = state.properties.find(p => p.id == propertyId);
    const area = prop.areas.find(a => a.id == areaId);
    if (itemId) {
      // const itemIndex = area.items.findIndex(i => i.id == itemId);
      // area.items[itemIndex] = {
      //   ...area.items[itemIndex],
      //   ...data
      // };
      const item = area.items.find(i => i.id == itemId);
      const {
        name, category, sub_category, note, description,
        purchase_date, approximate_price, brand_name, manufacturer,
        model_number, serial_number, per_piece_or_per_set, number_of_items,
        measurement_width, measurement_height, measurement_depth,
        year_purchased, month_purchased, country, condition, warranty_years,
        service_contract_company, extended_warranty_company,
        dimensions, item_weight, appraisal_value, heir_assigned_name, actual_cash_value,
        replacement_cost_value, auction_value, retail_value, asset_ownership_status, asset_assigned_to
      } = data;

      item.name = name;
      item.category = category;
      item.sub_category = sub_category;
      item.note = note;
      item.description = description;
      item.purchase_date = purchase_date;
      item.approximate_price = approximate_price;
      item.brand_name = brand_name;
      item.manufacturer = manufacturer;
      item.model_number = model_number;
      item.serial_number = serial_number;
      item.per_piece_or_per_set = per_piece_or_per_set;
      item.number_of_items = number_of_items;
      item.measurement_width = measurement_width;
      item.measurement_height = measurement_height;
      item.measurement_depth = measurement_depth;
      item.year_purchased = year_purchased;
      item.month_purchased = month_purchased;
      item.country = country;
      item.condition = condition;
      item.warranty_years = warranty_years;
      item.service_contract_company = service_contract_company;
      item.extended_warranty_company = extended_warranty_company;
      item.dimensions = dimensions;
      item.item_weight = item_weight;
      item.appraisal_value = appraisal_value;
      item.heir_assigned_name = heir_assigned_name;
      item.actual_cash_value = actual_cash_value;
      item.replacement_cost_value = replacement_cost_value;
      item.auction_value = auction_value;
      item.retail_value = retail_value;
      item.asset_ownership_status = asset_ownership_status;
      item.asset_assigned_to = asset_assigned_to;
    } else area.items.push(data);
  },
  removeItem(state, { propertyId, areaId, itemId }) {
    const prop = state.properties.find(p => p.id == propertyId);
    const area = prop.areas.find(a => a.id == areaId);
    const itemIndex = area.items.findIndex(item => item.id === itemId);
    if (itemIndex !== -1) {
      area.items.splice(itemIndex, 1);
    }
  }
};
